import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=667f8ad8&"
import script from "./secondStep.vue?vue&type=script&lang=js&"
export * from "./secondStep.vue?vue&type=script&lang=js&"
import style0 from "./secondStep.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports